Vue.filter('moverickDateTime', value => moment(value).format('DD/MM/YYYY HH:mm'))
